// extracted by mini-css-extract-plugin
export default {"summary":"_35Bc3","container":"+kv5Y","info":"FFx70","title":"_3x7m0","expandButton":"rA3vn","tickets":"_4oDGS","expanded":"Kwe2d"};